var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-dialog",
    {
      attrs: {
        title: "Tạo ca",
        visible: _vm.isOpenAddShiftMasterDialog,
        width: "1150px",
        "before-close": _vm.closeDialog,
        "close-on-click-modal": false,
        top: "4vh",
      },
      on: {
        "update:visible": function ($event) {
          _vm.isOpenAddShiftMasterDialog = $event
        },
      },
    },
    [
      _c(
        "el-form",
        {
          ref: "dataInput",
          attrs: {
            "label-width": "160px",
            model: _vm.dataInput,
            "label-position": "left",
            rules: _vm.rules,
          },
        },
        [
          _c(
            "el-row",
            { attrs: { gutter: 20 } },
            [
              _c(
                "el-col",
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "Tên ca", prop: "name" } },
                    [
                      _c("el-input", {
                        attrs: { placeholder: "Nhập tên ca" },
                        model: {
                          value: _vm.dataInput.name,
                          callback: function ($$v) {
                            _vm.$set(_vm.dataInput, "name", $$v)
                          },
                          expression: "dataInput.name",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-row",
            { attrs: { gutter: 20 } },
            [
              _c(
                "el-col",
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "Mô tả", prop: "description" } },
                    [
                      _c("el-input", {
                        attrs: {
                          rows: 3,
                          type: "textarea",
                          autosize: "",
                          placeholder: "Nhập mô tả",
                        },
                        model: {
                          value: _vm.dataInput.description,
                          callback: function ($$v) {
                            _vm.$set(_vm.dataInput, "description", $$v)
                          },
                          expression: "dataInput.description",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-row",
            { attrs: { gutter: 20 } },
            [
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: "Thời gian bắt đầu ca",
                        prop: "startTime",
                      },
                    },
                    [
                      _c("el-time-picker", {
                        attrs: {
                          "value-format": "HH:mm:ss",
                          format: "HH:mm:ss",
                          "picker-options": {
                            selectableRange: "00:00:00 - 23:59:59",
                          },
                          placeholder: "Thời gian bắt đầu ca",
                        },
                        on: { change: _vm.handleChangeStartTime },
                        model: {
                          value: _vm.dataInput.startTime,
                          callback: function ($$v) {
                            _vm.$set(_vm.dataInput, "startTime", $$v)
                          },
                          expression: "dataInput.startTime",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: "Thời gian kết thúc ca",
                        prop: "endTime",
                      },
                    },
                    [
                      _c("el-time-picker", {
                        attrs: {
                          "value-format": "HH:mm:ss",
                          format: "HH:mm:ss",
                          "picker-options": {
                            selectableRange: "00:00:00 - 23:59:59",
                          },
                          placeholder: "Thời gian kết thúc ca",
                        },
                        on: { change: _vm.handleChangeEndTime },
                        model: {
                          value: _vm.dataInput.endTime,
                          callback: function ($$v) {
                            _vm.$set(_vm.dataInput, "endTime", $$v)
                          },
                          expression: "dataInput.endTime",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-row",
            { attrs: { gutter: 20 } },
            [
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: { label: "Trạng thái sử dụng", prop: "isActive" },
                    },
                    [
                      _c(
                        "el-radio-group",
                        {
                          model: {
                            value: _vm.dataInput.isActive,
                            callback: function ($$v) {
                              _vm.$set(_vm.dataInput, "isActive", $$v)
                            },
                            expression: "dataInput.isActive",
                          },
                        },
                        [
                          _c("el-radio", { attrs: { label: true } }, [
                            _vm._v("Đang sử dụng"),
                          ]),
                          _c("el-radio", { attrs: { label: false } }, [
                            _vm._v("Ngừng sử dụng"),
                          ]),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-row",
            { attrs: { gutter: 20 } },
            [
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "Bộ phận áp dụng", prop: "objectType" } },
                    [
                      _c(
                        "el-select",
                        {
                          attrs: { placeholder: "Chọn bộ phận" },
                          on: { change: _vm.handleChangeTeamType },
                          model: {
                            value: _vm.dataInput.teamType,
                            callback: function ($$v) {
                              _vm.$set(_vm.dataInput, "teamType", $$v)
                            },
                            expression: "dataInput.teamType",
                          },
                        },
                        _vm._l(_vm.listTeamType, function (item) {
                          return _c("el-option", {
                            key: item.key,
                            attrs: { value: item.value, label: item.label },
                          })
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: { label: "Đối tượng áp dụng", prop: "objectType" },
                    },
                    [
                      _c(
                        "el-select",
                        {
                          attrs: {
                            disabled: "",
                            placeholder: "Chọn đối tượng",
                          },
                          model: {
                            value: _vm.dataInput.targetType,
                            callback: function ($$v) {
                              _vm.$set(_vm.dataInput, "targetType", $$v)
                            },
                            expression: "dataInput.targetType",
                          },
                        },
                        _vm._l(_vm.listObjectType, function (item) {
                          return _c("el-option", {
                            key: item.key,
                            attrs: { value: item.value, label: item.label },
                          })
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-row",
            { attrs: { gutter: 20 } },
            [
              _c(
                "el-col",
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: "Chọn ngày trong tuần",
                        prop: "applyDays",
                      },
                    },
                    [
                      _c(
                        "el-checkbox-group",
                        {
                          on: { change: _vm.updateDaysString },
                          model: {
                            value: _vm.selectedDays,
                            callback: function ($$v) {
                              _vm.selectedDays = $$v
                            },
                            expression: "selectedDays",
                          },
                        },
                        _vm._l(_vm.days, function (day) {
                          return _c(
                            "el-checkbox",
                            { key: day.value, attrs: { label: day.value } },
                            [
                              _vm._v(
                                "\n              " +
                                  _vm._s(day.label) +
                                  "\n            "
                              ),
                            ]
                          )
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-row",
            { attrs: { gutter: 20 } },
            [
              _c(
                "el-col",
                { attrs: { span: 7 } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: "Điểm danh tự động",
                        prop: "autoAttendanceEnable",
                      },
                    },
                    [
                      _c(
                        "el-radio-group",
                        {
                          on: { change: _vm.handleChangeAutoAttendance },
                          model: {
                            value: _vm.dataInput.autoAttendanceEnable,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.dataInput,
                                "autoAttendanceEnable",
                                $$v
                              )
                            },
                            expression: "dataInput.autoAttendanceEnable",
                          },
                        },
                        [
                          _c("el-radio", { attrs: { label: true } }, [
                            _vm._v("Có"),
                          ]),
                          _c("el-radio", { attrs: { label: false } }, [
                            _vm._v("Không"),
                          ]),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              this.dataInput.autoAttendanceEnable === true
                ? _c(
                    "el-col",
                    { attrs: { span: 8 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "Nguồn áp dụng",
                            prop: "autoAttendanceSource",
                          },
                        },
                        [
                          _c(
                            "el-select",
                            {
                              attrs: {
                                disabled: "",
                                placeholder: "Chọn nguồn",
                              },
                              model: {
                                value: _vm.dataInput.autoAttendanceSource,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.dataInput,
                                    "autoAttendanceSource",
                                    $$v
                                  )
                                },
                                expression: "dataInput.autoAttendanceSource",
                              },
                            },
                            _vm._l(_vm.listSource, function (item) {
                              return _c("el-option", {
                                key: item.key,
                                attrs: { value: item.value, label: item.label },
                              })
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              this.dataInput.autoAttendanceEnable === true
                ? _c(
                    "el-col",
                    { attrs: { span: 9 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "Chọn thiết bị",
                            prop: "allowDeviceIds",
                          },
                        },
                        [
                          _c(
                            "el-select",
                            {
                              attrs: {
                                placeholder: "Chọn thiết bị",
                                multiple: "",
                                "collapse-tags": "",
                              },
                              model: {
                                value: _vm.selectedDeviceIds,
                                callback: function ($$v) {
                                  _vm.selectedDeviceIds = $$v
                                },
                                expression: "selectedDeviceIds",
                              },
                            },
                            _vm._l(_vm.listIdDevice, function (item) {
                              return _c("el-option", {
                                key: item.key,
                                attrs: {
                                  value: item.id,
                                  label: item.nameDevice,
                                },
                              })
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          ),
          this.dataInput.autoAttendanceEnable === true
            ? _c(
                "el-row",
                { attrs: { gutter: 20 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "Tự động bắt đầu vào ca",
                            prop: "checkinStartTime",
                            "label-width": "240px",
                          },
                        },
                        [
                          _c("el-time-picker", {
                            attrs: {
                              "value-format": "HH:mm:ss",
                              format: "HH:mm:ss",
                              "picker-options": {
                                selectableRange: "00:00:00 - 23:59:59",
                              },
                              placeholder: "Tự động bắt đầu vào ca",
                            },
                            model: {
                              value: _vm.dataInput.checkinStartTime,
                              callback: function ($$v) {
                                _vm.$set(_vm.dataInput, "checkinStartTime", $$v)
                              },
                              expression: "dataInput.checkinStartTime",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "Tự động kết thúc vào ca",
                            prop: "checkinEndTime",
                            "label-width": "240px",
                          },
                        },
                        [
                          _c("el-time-picker", {
                            attrs: {
                              "value-format": "HH:mm:ss",
                              format: "HH:mm:ss",
                              "picker-options": {
                                selectableRange: "00:00:00 - 23:59:59",
                              },
                              placeholder: "Tự động kết thúc vào ca",
                            },
                            model: {
                              value: _vm.dataInput.checkinEndTime,
                              callback: function ($$v) {
                                _vm.$set(_vm.dataInput, "checkinEndTime", $$v)
                              },
                              expression: "dataInput.checkinEndTime",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
          this.dataInput.autoAttendanceEnable === true
            ? _c(
                "el-row",
                { attrs: { gutter: 20 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "Tự động bắt đầu kết thúc nghỉ ca",
                            prop: "checkoutStartTime",
                            "label-width": "240px",
                          },
                        },
                        [
                          _c("el-time-picker", {
                            attrs: {
                              "value-format": "HH:mm:ss",
                              format: "HH:mm:ss",
                              "picker-options": {
                                selectableRange: "00:00:00 - 23:59:59",
                              },
                              placeholder: "Bắt đầu kết thúc nghỉ ca",
                            },
                            model: {
                              value: _vm.dataInput.checkoutStartTime,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.dataInput,
                                  "checkoutStartTime",
                                  $$v
                                )
                              },
                              expression: "dataInput.checkoutStartTime",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "Tự động bắt đầu kết thúc nghỉ ca",
                            prop: "checkoutEndTime",
                            "label-width": "240px",
                          },
                        },
                        [
                          _c("el-time-picker", {
                            attrs: {
                              "value-format": "HH:mm:ss",
                              format: "HH:mm:ss",
                              "picker-options": {
                                selectableRange: "00:00:00 - 23:59:59",
                              },
                              placeholder: "Kết thúc nghỉ ca",
                            },
                            model: {
                              value: _vm.dataInput.checkoutEndTime,
                              callback: function ($$v) {
                                _vm.$set(_vm.dataInput, "checkoutEndTime", $$v)
                              },
                              expression: "dataInput.checkoutEndTime",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
          _c(
            "el-row",
            { attrs: { gutter: 20 } },
            [
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: "Tự động điểm danh ăn",
                        prop: "applyAttendanceEat",
                      },
                    },
                    [
                      _c(
                        "el-radio-group",
                        {
                          on: { change: _vm.handleChangeAutoAttendance },
                          model: {
                            value: _vm.dataInput.applyAttendanceEat,
                            callback: function ($$v) {
                              _vm.$set(_vm.dataInput, "applyAttendanceEat", $$v)
                            },
                            expression: "dataInput.applyAttendanceEat",
                          },
                        },
                        [
                          _c("el-radio", { attrs: { label: true } }, [
                            _vm._v("Có"),
                          ]),
                          _c("el-radio", { attrs: { label: false } }, [
                            _vm._v("Không"),
                          ]),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              this.dataInput.applyAttendanceEat === true
                ? _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "Chọn bữa ăn áp dụng",
                            prop: "meals",
                          },
                        },
                        [
                          _c(
                            "el-select",
                            {
                              attrs: {
                                placeholder: "Chọn bữa ăn",
                                multiple: "",
                                "collapse-tags": "",
                              },
                              model: {
                                value: _vm.meals,
                                callback: function ($$v) {
                                  _vm.meals = $$v
                                },
                                expression: "meals",
                              },
                            },
                            _vm._l(_vm.valueAttendanceEatList, function (item) {
                              return _c("el-option", {
                                key: item.key,
                                attrs: { value: item.value, label: item.label },
                              })
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "span",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer",
        },
        [
          _c(
            "el-button",
            {
              attrs: { type: "danger", size: "medium" },
              on: {
                click: function ($event) {
                  return _vm.closeDialog()
                },
              },
            },
            [
              _c("i", { staticClass: "el-icon-circle-close" }),
              _c("span", [_vm._v(_vm._s(_vm.$t("button.close")))]),
            ]
          ),
          _c(
            "el-button",
            {
              attrs: {
                type: "success",
                size: "medium",
                loading: _vm.loadingButton,
                mini: "",
              },
              on: {
                click: function ($event) {
                  return _vm.submitForm()
                },
              },
            },
            [
              _c("i", { staticClass: "el-icon-circle-check" }),
              _c("span", [_vm._v(_vm._s(_vm.$t("button.save")))]),
            ]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }